import React, { useState } from "react";
import "./AddTradeName.css";
import Modal from "react-bootstrap/Modal";
import BubbleSvgButton from "../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import FloatingTextFiled from "../../sharedPages/CommonComponents/FloatingTextFiled/FloatingTextFiled";
import useApi from "../../../helpers/apiHelper/requestHelper";
import { showNotificationToast, toastify } from "../../../helpers/toast/toastify";
import { useNavigate } from "react-router-dom";
import { setRefetchSpecificUser } from "../../../redux/multicommunity/multicommunity.js";
import { useDispatch, useSelector } from "react-redux";
import { storeUser } from "../../../redux/users/usersSlice.js";
const AddTradeName = () => {
  const [tradeName, setTradeName] = useState("");
  const api = useApi();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  async function updateScreen(screen, commmingFor) {
    const response = await api("post", "/users/updateTutorialScreen", {
      activeTutorial: screen,
      purposeOfJoining: commmingFor,
    });
    if (response.status) {
      const response = await api("get", "users/index");
      if (response?.status) {
        const { data } = response;
        if (dispatch && storeUser) dispatch(storeUser(data));
        if (data?.token) localStorage.setItem("token", data.token);

        // navigate("/leader/dashboard", {
        //   state: {
        //     by: "shajar",
        //   },
        // });
      }
    }
    toastify(response?.message);
  }
  // const handlePrev = async () => {
  //   await updateTraderPopUp(false, false);
  //   await updateScreen(4, "Verify Your Trading");
  // };

  async function updateTraderPopUp(showTradeNamePopUp, routeToDashboard) {
    const response = await api("post", "/users/updateTraderPopUp", {
      showTradeNamePopUp,
    });
    if (response.status) {
      const response = await api("get", "users/index");
      if (response?.status) {
        const { data } = response;
        if (dispatch && storeUser) dispatch(storeUser(data));
        if (data?.token) localStorage.setItem("token", data.token);
        if (routeToDashboard) {
          navigate("/leader/dashboard", {
            state: {
              by: "shajar",
            },
          });
        }
      }
    }
    toastify(response?.message);
  }

  const handleNext = async () => {
    const trimmedName = tradeName?.trim();
    if (!trimmedName) {
      toastify("Trade name is required");
      return;
    }

    if (trimmedName.length > 30) {
      toastify("Trade name must not be greater than 30 characters");
      return;
    }

    const response = await api("post", "authorizeNewonBoard/updateTradeName", {
      tradeName: trimmedName,
    });
    if (response?.status) {
      dispatch(setRefetchSpecificUser(true));
      // BUG: passing "" here wiped purposeOfJoining back to empty right after
      // the user picked "Verify Your Trading" in AskingServices — this screen
      // (AddTradeName) only ever renders from that flow (gated behind
      // user?.showTradeNamePopUp, only set true by the "Verify Your Trading"
      // branch in TutorialModal's handleClose), so clearing it here silently
      // broke any dashboard logic keyed on purposeOfJoining === "Verify Your
      // Trading" (e.g. VerifyAccountStat's trader-specific stats).
      // await updateScreen(null, "");
      await updateScreen(null, "Verify Your Trading");
      await updateTraderPopUp(false);
      // if(user?.role==="leader"&&user?.tradeName){
        showNotificationToast("Welcome onboard!", "Take a look around and hit start when you're ready to start verifying your trading.\n\nDon't forget:\n1) You can verify individual trades!\n2) Set it up to automatically share verified performances on social");
      // }
      
    } else {
      toastify(response?.message, "error");
    }
  };
  console.log(
    user?.user?.showTradeNamePopUp,
    user?.showTradeNamePopUp,
    "this is a user"
  );
  return (
    <div className="tutorial-modal-wrapper">
      {/* <Modal
        backdropClassName="custom-backdrop"
        centered
        dialogClassName="addTradeTutorialModal"
        animation={false}
        show={true}
      >
        <Modal.Body> */}
      <div className={`addTradeTutorialSlide`} style={{ paddingTop: "30px" }}>
        {/* <button
              className="addTradeheaderArrowBtn"
              onClick={handlePrev}
              type="button"
            >
              <img alt="" src={Arrow} />
            </button> */}
        <div className="addTradeTutorialContentWrap">
          <p className="title">Your Trader Name</p>
          <p className="desc">Name to associate with the verified trading</p>
          <div className="d-flex flex-column justify-content-center">
            <div className="mb-20px">
              <FloatingTextFiled
                className="onboardingInput addTradingNameInput"
                label="Trading Name"
                placeholder="Trading Name"
                type="Text"
                value={tradeName}
                onChange={(e) => setTradeName(e.target.value)}
              />
            </div>
            <BubbleSvgButton
              className="addTradeTutorialBtn"
              onClick={handleNext}
              text={"Done"}
              type="button"
              variant="black"
              containerStyling={{
                justifyContent: "center",
              }}
              mainDivStyle={{
                width: "auto",
                height: "auto",
                position: "absolute",
                left: "50%",
                bottom: "60px",
                transform: "translateX(-50%)",
              }}
            />
          </div>
        </div>
      </div>
      {/* </Modal.Body>
      </Modal> */}
    </div>
  );
};

export default AddTradeName;
